import { useEffect, useState } from "react";
import classNames from "classnames";
import "../../assets/scss/Components/Modal/modal.scss";
import { Button } from "../Button/Button";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { colorButton } from "../../enum/Button/colorButton.model";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import DataContainer from "../../services/DataContainer";
import { DisclaimerTexts } from "../../enum/enums";
import { DisclaimerSection } from "../Disclaimer-Section/DisclaimerSection";
import { logo } from "../../consts/logo";
import { Logo } from "../Logo/Logo";

type InfoModalProps = {
  setIsInfoOpen: (open: boolean) => void;
  infoLeaving?: boolean;
};

export const InfoModal = ({
  setIsInfoOpen,
  infoLeaving = false,
}: InfoModalProps) => {
  const [infoEnter, setInfoEnter] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setInfoEnter(true), 0);
    return () => clearTimeout(id);
  }, []);

  return (
    <div
      className={classNames(
        "email-modal h-full top-2/4 left-2/4 z-30 fixed -translate-y-1/2 -translate-x-1/2 transition-opacity duration-1000 ease-out",
        infoEnter && !infoLeaving ? "opacity-100" : "opacity-0"
      )}
    >
      <div className=" flex flex-col flex-wrap fixed top-1/2 left-1/2 -translate-y-1/2 max-h-screen -translate-x-1/2">
        <div className="disclaimer--modal bg-white border rounded-md border-gray-suva relative">
          <div className="relative flex flex-col">
            <div className="flex justify-between items-center h-16 px-6 border-b border-[rgb(233,233,233)]">
              <Logo>
                {logo.InfoShield}
              </Logo>
              <Button
                variant={VarianButtonEnum.DEFAULT}
                icon={IconModelEnum.CLOSE_GREY}
                bgColor={colorButton.WHITE}
                onClickEvent={() => setIsInfoOpen(false)}
                customClassNames="border border-px p-2 cursor-pointer opacity-50 border border-gray-stone"
              />
            </div>
            <div>
              <DisclaimerSection
                positionOfTitle="left"
                positionOfContent="left"
                positionOfLinks="right"
                isInfoModal={true}
                links={[
                  {
                    title: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.PRIVACY_BUTTON),
                    link: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.PRIVACY_URL),
                  },
                  {
                    title:  DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.COOKIES_BUTTON),
                    link: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.COOKIES_URL),
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
